import React, { memo } from 'react';
import {
  FormPageInputItemMultipleSelectionCheckbox,
  MultipleSelectionCheckboxListInput,
  MultipleSelectionCheckboxListInputProps,
  MultipleSelectionPropertyCheckbox,
} from 'shared';
import {
  MultipleSelectionInputItemProps,
  MultipleSelectionEvents,
} from './shared';

type Subtexts = MultipleSelectionCheckboxListInputProps['subtexts'];

type Props = MultipleSelectionInputItemProps<
  MultipleSelectionPropertyCheckbox,
  FormPageInputItemMultipleSelectionCheckbox
> & {
  values: FormPageInputItemMultipleSelectionCheckbox['values'];
  subtexts: FormPageInputItemMultipleSelectionCheckbox['subtexts'];
} & MultipleSelectionEvents;

export const MultipleSelectionCheckbox: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    values,
    onSelectChange,
    onSubtextChange,
    onSubtextBlur,
    className,
    errorMessages,
    displayError,
    subtexts,
  }) => {
    const { propertyId, inputFormat, candidates } = property;
    const handleChange = (value: number | null) => {
      if (value == null) {
        return;
      }
      onSelectChange(value);
    };
    // multiSelectionではvalueがnullになることは無いが、型的にnullがありうるのでハンドリング
    const subtextsValue: Subtexts =
      (subtexts?.filter((subtext) => subtext.value != null) as Subtexts) ?? [];
    const handleSubtextsChange: MultipleSelectionCheckboxListInputProps['onSubtextChange'] =
      (value, subtext) => {
        onSubtextChange(value, subtext);
      };
    const handleSubtextsBlur: MultipleSelectionCheckboxListInputProps['onSubtextBlur'] =
      (value, subtext) => {
        onSubtextBlur(value, subtext);
      };
    const candidatesExcludeUnselected = candidates.filter(
      (candidate) => candidate.value != null
    );
    return (
      <MultipleSelectionCheckboxListInput
        propertyId={propertyId}
        displayChoiceNumber={inputFormat.isNumbering}
        values={values ?? []}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onSelectChange={handleChange}
        design={design}
        className={className}
        items={candidatesExcludeUnselected}
        subtexts={subtextsValue}
        onSubtextChange={handleSubtextsChange}
        onSubtextBlur={handleSubtextsBlur}
      />
    );
  }
);
